import { render, staticRenderFns } from "./ApplicantNotificationButton.vue?vue&type=template&id=28b1121c&scoped=true&"
import script from "./ApplicantNotificationButton.vue?vue&type=script&lang=js&"
export * from "./ApplicantNotificationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1121c",
  null
  
)

export default component.exports